module.exports = __webpack_public_path__ + "img/default.fa20cd64.svg";